import { EntityAction } from '../../BaseEntity/EntityAction';
import { injectable } from 'inversify';

@injectable()
export class ComplaintTableActions extends EntityAction {


}